import React from 'react';
import data from "../../../data/mobile-fleet/internationalRates.json";
import Heading from "../elements/Heading";
import ResponsiveTable from "../elements/ResponsiveTable";
import Loader from "../elements/Loader";
import CountrySearch from "../components/CountrySearch";

class MobileInternationalRates extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			noResult: false,
			isLoadingRates: false,
			title: data.title,
			description: data.description,
			search: '',
			rates: []
		};

		this.noResults = [{zone: 'no-results', country: 'No country found.', additional: ''}];
	}

	handleChange(event) {
		this.setState({
			search: event.target.value,
			noResult: false
		}, this.getData.bind(this));
	}

	getData() {
		if (this.state.search.length > 1) {
			clearTimeout(this.timer);

			this.setState({
				isLoadingRates: true,
				rates: []
			});

			this.timer = setTimeout(() => {
				this.search(this.state.search);
			}, 500);
		}
	}

	search(search) {
        fetch(`/api/searchMobileInternationalRates/${search}`)
            .then(result => result.json())
            .then(result => {
                this.setState({isLoadingRates: false});
                if (result.length > 0) {
                    this.setState({rates: result});
                } else {
                    this.setState({noResult: true});
                }
            }).catch(error => {
                console.log(error);
            }
        );
	}

	render() {
		const TableData = {
			headings: ['Destination', 'Zone', 'Price/min'],
			rows: this.state.rates
		};

		const Result = () => {
			if (this.state.isLoadingRates) {
				return <div className="w-100 text-center"><Loader whiteBg={true} /></div>;
			} else if (this.state.noResult) {
				return <div className="text-center">No results found for "{this.state.search}".</div>;
			} else if (this.state.rates.length > 0) {
				return <ResponsiveTable data={TableData} />;
			} else {
				return <div className="text-center">Start typing the country to find the rates.</div>;
			}
		};

		return (
			<div className="mobile-international-rates">
				<div className="row">
					<div className="col-12 col-lg-8 col-lg-offset-2">
						<Heading title={this.state.title} className="text-center mb-5">
                            <p className="text-center" dangerouslySetInnerHTML={{__html: this.state.description}} />
                        </Heading>
						<CountrySearch title="Find your rates:" search={this.state.search} countryList={[]} handleChange={this.handleChange.bind(this)} handleSelect={() => {}}/>
						{Result()}
					</div>
				</div>
			</div>
		);
	}

}

export default MobileInternationalRates;


// WEBPACK FOOTER //
// ./resources/assets/js/mobileFleet/MobileInternationalRates.js